import * as htmlToImage from 'html-to-image';

export const exportToPNG = async (id: string, filename: string) => {
  const doc = document.getElementById(id);
  if (doc) {
    htmlToImage
      .toPng(doc, { backgroundColor: '#FFF' })
      .then(function (dataUrl) {
        download(dataUrl, `${filename}.png`);
      });
  }
};

export function exportToJsonFile(jsonData: JSON) {
  let dataStr = JSON.stringify(jsonData);
  let dataUri =
    'data:application/json;charset=utf-8,' + encodeURIComponent(dataStr);

  let exportFileDefaultName = 'data.json';

  let linkElement = document.createElement('a');
  linkElement.setAttribute('href', dataUri);
  linkElement.setAttribute('download', exportFileDefaultName);
  linkElement.click();
}

export function download(blob: string, filename: string) {
  let dataUri = blob;
  let linkElement = document.createElement('a');
  linkElement.setAttribute('href', dataUri);
  linkElement.setAttribute('download', filename);
  linkElement.click();
  URL.revokeObjectURL(linkElement.href);
  linkElement.remove();
}

export const downloadBlob = (blob: Blob, filename: string) => {
  const url = window.URL.createObjectURL(blob);
  let linkElement = document.createElement('a');
  linkElement.setAttribute('href', url);
  linkElement.setAttribute('download', filename);
  linkElement.click();
  URL.revokeObjectURL(linkElement.href);
  linkElement.remove();
};

export const downloadPDFFromBase64 = (base64: string, studyName: string) => {
  const linkSource = `data:application/pdf;base64,${base64}`;
  const downloadLink = document.createElement('a');
  const fileName = `${studyName}.pdf`;

  downloadLink.href = linkSource;
  downloadLink.download = fileName;
  downloadLink.click();
};
